/* unplugin-vue-components disabled */import { render } from "./myfield.vue?vue&type=template&id=d04cea68&scoped=true&ts=true"
import script from "./myfield.vue?vue&type=script&lang=ts"
export * from "./myfield.vue?vue&type=script&lang=ts"

import "./myfield.vue?vue&type=style&index=0&id=d04cea68&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04cea68"]])

export default __exports__